import { useDispatch } from "react-redux";
import { useState } from "react";
import { Button, Modal } from "semantic-ui-react";
import { sysAPI } from "../../../apis/SysAPI";
import { setSnackbar } from "../../../actions/snackbar.actions";

const RemoveAllClientsTheIntegration = ({advisorId, refreshFunction, disabled}) => {
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleRemoveIntegration = async () => {
        setLoading(true)
        try {
            const {data} = await sysAPI.post('/remove-integration-clients', {
                owners: [advisorId],
            })
            dispatch(setSnackbar({message: data.message || "integration removed 🫱🏼‍🫲🏽"}))
            if(refreshFunction){
                await refreshFunction()
            }
            setOpenModal(false)
        } catch (error) {
            console.error({error})
            const message = error?.response?.data?.message || error.message || "There was an error"
            dispatch(setSnackbar({message, status: "error"}))
        }
        setLoading(false)
    }


    if(!advisorId){
        return <></>
    }

    return <>
        <Button disabled={disabled || loading} loading={loading} color="orange" onClick={() => setOpenModal(true)}>Remove integration for all</Button>

        <Modal size="tiny" open={openModal} onClose={() => setOpenModal(false)} onOpen={() => setOpenModal(true)}>
            <Modal.Header>
                Remove integration for all
            </Modal.Header>
            <Modal.Content>
                <div style={{display: "grid", gap: "10px"}}>
                    <div>
                        Are you sure you want to remove the integration?
                    </div>
                    <div>
                        This action cannot be undone and will only affect clients who are owners. Shared clients will not be affected
                    </div>

                </div>
                </Modal.Content>
            <Modal.Actions>
            <Button onClick={() => setOpenModal(false)} disabled={loading}>Cancel</Button>
            <Button onClick={() => handleRemoveIntegration()} color="orange" loading={loading}>
                Remove all
            </Button>
            </Modal.Actions>
        </Modal>
    </>
}

export default RemoveAllClientsTheIntegration